import { richTextHasContent } from "./richTextHasContent"

/**
 * A static module renders what the editor authored; a dynamic one renders the configured
 * offer field, and hides when the ATS delivers nothing for it rather than leaving an empty
 * bordered panel on the live page (same rule as `jobTextFieldHasContent`).
 *
 * The static branch mirrors CRCompanyInfo's own `showLogo || companyTitle || companyBody`
 * so tracking fires only for a module a candidate can actually see. Deliberate coupling:
 * if that guard changes in crossroads, this has to follow. The body goes through the same
 * rich-text check as the dynamic one: it is a TipTap field, and an emptied editor persists
 * `<p></p>` rather than "".
 *
 * A missing logo alone does NOT hide a dynamic module: `company_logo` is routinely blank
 * in the feed, while the text is the actual payload.
 */
export function companyInfoHasContent(module: ContentModule, job: FlatJob | undefined): boolean {
  if (!module?.isDynamic)
    return staticHasContent(module)

  if (!job)
    return false

  const field = (module?.config as OfferFieldConfig | undefined)
    ?.general?.text?.offerField?.value

  if (!field)
    return false

  return richTextHasContent((job as Record<string, unknown>)[field])
}

function staticHasContent(module: ContentModule): boolean {
  const general = (module?.config as CompanyInfoStaticConfig | undefined)?.general
  const showsLogo = !!general?.style?.showImage && !!general?.logo?.media?.url

  return showsLogo || !!general?.texts?.title || richTextHasContent(general?.texts?.body)
}

interface CompanyInfoStaticConfig {
  general?: {
    texts?: {
      title?: string
      body?: string
    }
    logo?: {
      media?: {
        url?: string
      }
    }
    style?: {
      showImage?: boolean
    }
  }
}
